import React, { useState, useEffect, Fragment, useMemo } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Select, Table, Drawer, Dropdown, Checkbox, Tag,
  Button,
  Divider,
  Tooltip,
} from 'antd';
import {
  ControlOutlined, FilterOutlined, SwapLeftOutlined, SwapRightOutlined,
} from '@ant-design/icons';
import {
  toISTDate, dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums,
} from '@Apis/constants';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import ProductActions from '@Actions/productActions';
import Helpers from '@Apis/helpers';
import searchIcon from '@Images/icons/icon-search.png';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import SelectDepartment from '@Components/Common/SelectDepartment';
import CMActions from '@Actions/settings/cmActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons';
import PRZText from '../../Common/UI/PRZText';
import ViewIndent from './ViewIndent';
import MoreInfoMobileView from '../../Common/MoreInfoMobileView';
import PRZSelect from '../../Common/UI/PRZSelect';
import useCheckPortrait from '../../../hooks/useCheckPortrait';
import './style.scss';
import UserSavedFilterViewSelector from '@Components/Common/UserSavedFilterViewSelector';
import { textTruncate } from '../../Common/UI/PRZHelper/helpers';


const { Option } = Select;

function IssueStock({
  getIndent, user, indents, getIndentLoading, history, getIndentByIdSuccess, customFieldsProps, getDocCFV2Loading, getDocCFV2, getDocCFV2Success, departments, getCM, customMessageStockAdjustment,
  location,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [openIndentModalView, setOpenIndentModalView] = useState(false);
  const [selectedIndent, setSelectedIndent] = useState(null);
  const [selectedAdjustmentType, setSelectedAdjustmentType] = useState(null);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [isUserReady, setIsUserReady] = useState(false);
  const [fixedColumns, setFixedColumns] = useState(['ADJUSTMENT_NO']);
  const [selectedAdjustment, setSelectedAdjustment] = useState(null);
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);
  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-sa') ? JSON.parse(localStorage.getItem('prcz-page-columns-sa')) : {
    ADJUSTMENT_NO: {
      label: 'Adjustment#',
      visible: true,
    },
    LOCATION: {
      label: 'Location',
      visible: true,
    },
    ADJUSTMENT_TYPE: {
      label: 'Adjustment Type',
      visible: true,
    },
    ADJUSTMENT_REASON: {
      label: 'Adjustment Reason',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
    ADJUSTMENT_DATE: {
      label: 'Adjustment Date',
      visible: true,
    },
    CREATED_DATE: {
      label: 'Created Date',
      visible: true,
    },
    ITEMS: {
      label: 'Items',
      visible: true,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
  });
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);

  // filter states
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);

  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const showDrawer = () => setIsDrawerVisible(true);
  const closeDrawer = () => setIsDrawerVisible(false);
  const indentColumn = () => {
    const columns = [
      // {
      //   title: '',
      //   render: (record) => (
      //     <div
      //       className="mobile-list__item"
      //       onClick={() => {
      //         setOpenIndentModalView(true);
      //         setSelectedIndent(record);
      //         getIndentByIdSuccess(null);
      //       }}
      //     >
      //       <div style={{ display: 'flex' }}>
      //         <H3Text text={`#${record?.ia_number}`} className="mobile-list__item-number" />
      //         <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
      //           {Helpers.getStatusColor(record.status).text?.toUpperCase()}
      //         </div>
      //       </div>
      //       <div style={{ marginBottom: '5px' }}>
      //         {record?.adjustment_entity_type?.replaceAll('_', ' ') === 'OUTWARD'
      //           && (
      //             <div className="ia-type-tag" style={{ backgroundColor: '#f15353' }}>
      //               <SwapRightOutlined />
      //               <H3Text text="Outgoing" className="" />
      //             </div>
      //           )}
      //         {record?.adjustment_entity_type?.replaceAll('_', ' ') === 'INWARDS'
      //           && (
      //             <div className="ia-type-tag" style={{ backgroundColor: '#2fbc6e' }}>
      //               <SwapLeftOutlined />
      //               <H3Text text="Incoming" className="" />
      //             </div>
      //           )}
      //       </div>
      //       <H3Text text={`Location - ${record?.tenant_info?.tenant_name}`} className="mobile-list__item-info" />
      //       <H3Text text={`Reason: ${record?.adjustment_reason?.replaceAll('_', ' ')?.toProperCase()}`} className="mobile-list__item-info" />
      //       <H3Text text={`Item(s): ${record?.lines_count}`} className="mobile-list__item-info" />
      //       <div className="mobile-list__item-footer">
      //         <H3Text text={`Requested by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer-left" />
      //       </div>
      //     </div>

      //   ),
      //   responsive: ['xs'],

      // },
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText className="mobile-list__card_item-number" text={`#${record?.ia_number ? record.ia_number : 'N/A'}`} />
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}
                  text={Helpers.getStatusColor(record.status).text?.toUpperCase()}
                  className="mobile-list__card__status"
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <PRZText
                  text={`Location - ${record?.tenant_info?.tenant_name} (${record?.tenant_department_alias_name})`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Adjustment Reason - ${record?.adjustment_reason?.replaceAll('_', ' ')?.toProperCase()}`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Created Date - ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Adjustment Date - ${toISTDate(record?.adjustment_date).format('DD/MM/YYYY')}`}
                  className="mobile-list__card_item-details"
                />
              </div>
              <div className="mobile-list__card_body-right">
                <Tooltip
                  color="white"
                  placement="top"
                  title={(
                    <PRZText className="mobile-list__card_item__tooltip_text-color" text="Items" />
                  )}
                >
                  <PRZText
                    text={record?.lines_count}
                  />
                </Tooltip>
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <Tooltip
                  title={(
                    <PRZText
                      className="mobile-list__card_item__tooltip_text-color mobile-list__card_item__category__tooltip"
                      text="Adjustment Type"
                    />
                  )}
                  color="white"
                >
                  {record?.adjustment_entity_type?.replaceAll('_', ' ') === 'OUTWARD'
                    && (
                      <div className="ia-type-tag" style={{ backgroundColor: '#f15353' }}>
                        <SwapRightOutlined />
                        <H3Text text="Outgoing" className="" />
                      </div>
                    )}
                  {record?.adjustment_entity_type?.replaceAll('_', ' ') === 'INWARDS'
                    && (
                      <div className="ia-type-tag" style={{ backgroundColor: '#2fbc6e' }}>
                        <SwapLeftOutlined />
                        <H3Text text="Incoming" className="" />
                      </div>
                    )}
                </Tooltip>
              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedAdjustment(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'ADJUSTMENT #',
        render: (text, record) => (
          <div className="min-width-115">
            {record?.ia_number}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns.ADJUSTMENT_NO.visible ? 'display-none' : '',
        fixed: 'left',
      },
      {
        title: 'LOCATION',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_info?.tenant_name} />
            <H3Text text={record?.tenant_department_alias_name} className="table-subscript" />
          </div>
        ),
        className: !visibleColumns.LOCATION.visible ? 'display-none' : '',
      },
      {
        title: 'ADJUSTMENT TYPE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-115">
            {record?.adjustment_entity_type?.replaceAll('_', ' ') === 'OUTWARD'
              && (
                <div className="ia-type-tag" style={{ backgroundColor: '#f15353' }}>
                  <SwapRightOutlined />
                  <H3Text text="Outgoing" className="" />
                </div>
              )}
            {record?.adjustment_entity_type?.replaceAll('_', ' ') === 'INWARDS'
              && (
                <div className="ia-type-tag" style={{ backgroundColor: '#2fbc6e' }}>
                  <SwapLeftOutlined />
                  <H3Text text="Incoming" className="" />
                </div>
              )}
          </div>
        ),
        className: !visibleColumns.ADJUSTMENT_TYPE.visible ? 'display-none' : '',
      },
      {
        title: 'ADJUSTMENT REASON',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-150">
            {record?.adjustment_reason?.replaceAll('_', ' ')?.toProperCase()}
            {record?.remarks ? <H3Text
              text={textTruncate({
                text: record?.remarks,
                truncateTextLength: 25,
                enableTooltip: true,
              })} className="table-subscript" /> : ''}
          </div>
        ),
        className: !visibleColumns.ADJUSTMENT_REASON.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'ADJUSTMENT DATE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-130">
            <div className="column-date">
              {toISTDate(record?.adjustment_date).format('DD/MM/YYYY')}
            </div>
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        className: !visibleColumns.ADJUSTMENT_DATE.visible ? 'display-none' : '',
      },
      {
        title: 'CREATED DATE',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="column-date min-width-100">
            {toISTDate(record?.created_at).format('DD/MM/YYYY')}
          </div>
        ),
        className: !visibleColumns.CREATED_DATE.visible ? 'display-none' : '',
      },
      {
        title: 'ITEM(s)',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (
          <div className="min-width-50">
            {item?.lines_count}
          </div>
        ),
        className: !visibleColumns.ITEMS.visible ? 'display-none' : '',
      },
      {
        title: 'STATUS',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (item) => (
          <div className="min-width-70">
            <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>{Helpers.getStatusColor(item.status).text}</div>
          </div>
        ),
        className: !visibleColumns.STATUS.visible ? 'display-none' : '',
      },
    ];
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.map((custom) => {
        columns.push({
          title: custom.field_name?.toUpperCase(),
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record.custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    columns.push({
      title: '',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isPortrait,
      key: 'action',
      className: 'list__actions-column',
      render: (text, record) => (
        <div className="list__actions" style={{ display: 'list-item' }}>
          <div
            className="list__actions-button list__actions-button-dark"
            onClick={() => {
              setOpenIndentModalView(true);
              setSelectedIndent(record);
              getIndentByIdSuccess(null);
            }}
          >
            View
          </div>
        </div>
      ),
      fixed: 'right',
    });
    return columns.filter((item) => !item.hidden);
  };

  const adjustmentTypes = [
    'STOLEN_GOODS',
    'DAMAGED_GOODS',
    'STOCK_WRITTEN_OFF',
    'OFFLINE_PURCHASE',
    'INVENTORY_REVALUATION',
  ];

  const pushParamsToUrl = (page, limit, currentTenant, currentAdjustmentType, word, dept, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (currentAdjustmentType) url += `&adjustment_type=${currentAdjustmentType}`;
    if (word) url += `&keyword=${word}`;
    if (dept) url += `&department=${dept}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    history.push(url);
  };

  // common function to get filter value by key
  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {

    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'adjustment_type',
        filter_value: Helpers.getValueFromUrl('adjustment_type') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'department',
        filter_value: Number(Helpers.getValueFromUrl('department')) || '',
        filter_type: filterTypeEnums.NUMBER,
      }
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => {
    return [
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: [user?.tenant_info?.tenant_id],
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'adjustment_type',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'department',
        filter_value: Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility ? Number(Helpers.getDepartmentId(user)) : '',
        filter_type: filterTypeEnums.NUMBER,
      },
    ];
  }, []);
  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.STOCK_ADJUSTMENT,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);

  useEffect(() => {
    const ia_id = new URLSearchParams(location.search).get('ia_id');
    new URLSearchParams(location.search).delete('ia_id');

    if (ia_id) {
      const tenant_id = new URLSearchParams(location.search).get('tenant_id');
      setOpenIndentModalView(true);
      setSelectedIndent({ ia_id, tenant_id });
      getIndentByIdSuccess(null);
    }
    if (user?.tenant_info?.org_id) {
      setSelectedFilterView(systemDefaultUserView);
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Number(Helpers.getValueFromUrl('limit') || limit));
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
      // setSelectedAdjustmentType(Helpers.getValueFromUrl('adjustment_type'));
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setKeyword(Helpers.getValueFromUrl('keyword'));
      // if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
      //   setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
      //   setSelectedDepartment(Helpers.getValueFromUrl('department') || Helpers.getDepartmentId(user));
      // } else {
      //   setSelectedDepartment(Helpers.getValueFromUrl('department'));
      // }
      getCM(user?.tenant_info?.org_id, '', 'STOCK ADJUSTMENT');
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'STOCK_ADJUSTMENT',
      };
      getDocCFV2(payload);
      setIsUserReady(true);
    }
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, selectedTenant, selectedAdjustmentType, searchKeyword, selectedDepartment, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getIndent(Helpers.getValueFromUrl('page') || currentPage, selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ)?.join(','),
        '', Helpers.getValueFromUrl('adjustment_type'), Helpers.getValueFromUrl('keyword'), Helpers.getValueFromUrl('department'), limit);
    }
  }, [selectedAdjustmentType, selectedTenant, searchKeyword, currentPage, limit, selectedDepartment]);

  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-sa'))?.[customField.cf_id]?.visible || false,

        };
      });
      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);
  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedAdjustmentType(tempFilterValues.adjustment_type);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setSelectedDepartment(tempFilterValues.department);

        if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
          setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
          // setSelectedDepartment(Helpers.getValueFromUrl('department') || Helpers.getDepartmentId(user)?.toString());
        } else {
          // setSelectedDepartment(Helpers.getValueFromUrl('department'));
        }
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  const stockAdjustmentOptions = customMessageStockAdjustment?.data?.map((adjustment) => ({
    key: adjustment.message,
    value: adjustment.message,
    label: adjustment.message?.replaceAll('_', ' ')?.toProperCase(),
  }));

  return (
    <Fragment>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`MR # ${selectedAdjustment?.ia_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedAdjustment?.custom_fields}
        />
      </Drawer>
      <div className="doc-list__wrapper indent__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__header-wrapper indent__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for stock adjustments..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right indent__table-header__left">
                <div className="doc-list__buttons-wrapper">
                  {Helpers.getPermission(Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.CREATE, user) && (
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Adjustment"
                      onClick={() => history.push('/inventory/indent/create')}
                      customClass="add-button"
                    />
                  )}
                  {Helpers.getPermission(Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.CREATE, user) && (
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+"
                      onClick={() => history.push('/inventory/indent/create')}
                      customClass="indent__add-button-mobile"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
                    setLimit(tempFilterValues.limit || limit);
                    setSelectedTenant(tempFilterValues.tenant);
                    setSelectedAdjustmentType(tempFilterValues.adjustment_type);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedDepartment(tempFilterValues.department);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.STOCK_ADJUSTMENT}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search results for -
                    &nbsp;
                    <span><b><i>{searchKeyword}</i></b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {selectedAdjustmentType && (
                  <Tag closable onClose={() => { setSelectedAdjustmentType(null); }} color="#2d7df7">
                    Adjustment Type -
                    &nbsp;
                    <span><b>{selectedAdjustmentType?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {/* { */}
                {/*  (startDateMomentEpoch && endDateMomentEpoch) ? ( */}
                {/*      <Tag */}
                {/*          closable */}
                {/*          onClose={() => { */}
                {/*            setStartDateMomentEpoch(null); */}
                {/*            setEndDateMomentEpoch(null); */}
                {/*          }} */}
                {/*          color="#2d7df7" */}
                {/*      > */}
                {/*        {' '} */}
                {/*        From: */}
                {/*        &nbsp; */}
                {/*        <span><b>{dayjs(startDateMomentEpoch).format('DD/MM/YYYY')}</b></span> */}
                {/*        &nbsp; */}
                {/*        To: */}
                {/*        &nbsp; */}
                {/*        <span><b>{dayjs(endDateMomentEpoch).format('DD/MM/YYYY')}</b></span> */}
                {/*      </Tag> */}
                {/*  ) : '' */}
                {/* } */}
              </div>
            </div>

            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${indents?.count || '0'} Manual Stock Adjustments`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        <div className="action-buttons">
                          <div className="action-button" onClick={showDrawer}>
                            <H3Text text="Filters" className="action-button-text" />
                            <FilterOutlined />
                          </div>
                        </div>
                        <Drawer
                          open={isDrawerVisible}
                          width="420px"
                          mask
                          onClose={closeDrawer}
                          destroyOnClose
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        >
                          <div className="custom-drawer__header-wrapper">
                            <div
                              className="custom-drawer__header"
                              style={{ width: '370px' }}
                            >
                              <H3Text
                                text="Apply Filters"
                                className="custom-drawer__title"
                              />
                              <H3Image
                                src={closeIcon}
                                className="custom-drawer__close-icon"
                                onClick={closeDrawer}
                              />
                            </div>
                          </div>
                          <div className="header__filter__container-drawer">
                            <div className="filter__container filter__container-section">
                              <div className="filter__title">Business Unit</div>
                              <TenantSelector
                                selectedTenant={selectedTenant}
                                showSearch
                                onChange={(value) => {
                                  setSelectedTenant(value);
                                }}
                                placeholder="Select Business Unit"
                                isMultiple
                                hideTitle
                                includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ)}
                              />
                            </div>
                            <div className="filter__container filter__container-section">
                              <div className="filter__title"> Select Department </div>
                              <div className="sales-orders__header__section-status">
                                <SelectDepartment
                                  title="Select Department"
                                  hideTitle
                                  selectedDepartment={Number(selectedDepartment) || ''}
                                  noDropdownAlign
                                  onChange={(value) => {
                                    setSelectedDepartment(value?.department_id.toString() || '');
                                    setCurrentPage(1);
                                  }}
                                  disabled={departmentLevelVisibility}
                                />
                              </div>
                            </div>
                            <div className="filter__container inventory__header__section-status filter__container-section">
                              <div className="filter__title">Adjustment Reason</div>
                              <PRZSelect
                                value={selectedAdjustmentType}
                                className="indent-reason-input"
                                onChange={(value) => {
                                  setSelectedAdjustmentType(value);
                                }}
                                placeholder="Search By Reason"
                                options={stockAdjustmentOptions}
                              />
                            </div>
                          </div>
                        </Drawer>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={() => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                          localStorage.setItem('prcz-page-columns-sa', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                              {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={() => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumns[key].visible;
                                            localStorage.setItem('prcz-page-columns-sa', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                bordered
                showHeader
                loading={getIndentLoading || getDocCFV2Loading}
                size="small"
                scroll={!isMobileOrPortrait && !!indents?.result?.inventory_adjustments?.length ? { x: 'max-content', y: 'calc(100dvh - 140px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && !!indents?.result?.inventory_adjustments?.length}
                columns={indentColumn()}
                dataSource={indents?.result?.inventory_adjustments || []}
                currentPage
                pagination={
                  {
                    defaultCurrent: currentPage,
                    current: currentPage,
                    total: indents ? indents.count : 0,
                    pageSize: limit,
                    onChange: (page, pageSize) => {
                      setCurrentPage(page);
                      setLimit(pageSize);
                    },
                    position: ['bottomLeft'],
                    showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                    showSizeChanger: true,
                    pageSizeOptions: [10, 25, 50, 100],
                  }
                }
              />
            </div>
          </div>
        </div>
      </div>
      <Drawer
        onClose={() => {
          setOpenIndentModalView(false);
          getIndent(currentPage, selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ)?.join(','), '', selectedAdjustmentType, '', '', limit);
        }}
        open={openIndentModalView}
        width="1070px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '1025px' }}>
            <H3Text text="View Stock Adjustment" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setOpenIndentModalView(false)} />
          </div>
        </div>
        <ViewIndent
          selectedIndentId={selectedIndent?.ia_id}
          callback={() => {
            setOpenIndentModalView(false);
            getIndent(currentPage, selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVENTORY_INDENT, Helpers.permissionTypes.READ)?.join(','), '', selectedAdjustmentType, '', '', limit);
          }}
        />
      </Drawer>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, ProductReducers, CFV2Reducers, DepartmentReducers, CMReducers,
}) => ({
  user: UserReducers.user,
  indents: ProductReducers.indents,
  getIndentLoading: ProductReducers.getIndentLoading,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  customFieldsProps: CFV2Reducers.cfV2DocStockAdjustment,
  departments: DepartmentReducers.departments,
  customMessageStockAdjustment: CMReducers.customMessageStockAdjustment,
});

const mapDispatchToProps = (dispatch) => ({
  getIndent: (page, tentantId, indentId, adjustmentEntityType, searchKeyword, department, limit) => dispatch(
    ProductActions.getIndent(page, tentantId, indentId, adjustmentEntityType, searchKeyword, department, limit),
  ),
  getIndentByIdSuccess: (selectedIndent) => dispatch(ProductActions.getIndentByIdSuccess(selectedIndent)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
  getCM: (orgId, entityId, entityType, page, limit) => dispatch(CMActions.getCM(orgId, entityId, entityType, page, limit)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IssueStock));
